import {
  showNotificationAction,
  PERMISSIONS_VIOLATION_FOUND,
} from '../actions';
import { getIsPackageDeepLinking } from '../selectors';
import { NotificationTypes, NotificationLevels } from '@adsk/bim360-matrix-react-components';
import T from 'i18n-react';
import lodashGet from 'lodash/get';
import featureFlags, { FEATURE_FLAGS } from '../../utils/featureFlags';

const dispatchNotificationAction = (store) => {
  store.dispatch(showNotificationAction({
    type: NotificationTypes.SNACKBAR,
    level: NotificationLevels.ERROR,
    message: T.translate('permissionsErrors.notificationMessage'),
  }));
};

export default () => {
  return store => next => action => {
    const state = store.getState();
    if (featureFlags.get(FEATURE_FLAGS.PERMISSIONS_HANDLING)) {
      const isDeepLinking = getIsPackageDeepLinking(state) || lodashGet(action, 'meta.isDeepLinking');
      let hasGrowled = false;

      // eslint-disable-next-line default-case
      switch (action.type) {
        case PERMISSIONS_VIOLATION_FOUND: {
          // TODO: BTLV-7864 - Once viewType is properly handled for issueDetailsModal we need to verify that this actually works (should work out of the box unless viewType structure changes (e.g subViewType)).
          if (isDeepLinking) {
            dispatchNotificationAction(store);
            hasGrowled = true;
          }
          action.meta = Object.assign({}, action.meta, { hasGrowled });
          break;
        }
      }
    }
    return next(action);
  };
};

